import "../../css/GlobalStyles.css";
import React, { ReactNode, memo, useMemo, useRef, useState } from "react";
import TopHeader from "../TopHeader";
import { useSelector, useDispatch } from "react-redux";
import {
  LoginState,
  getAccountState,
  toggleInCreatorMode,
} from "../../redux/slices/accountSlice";
import CreatorModeSidebar from "./CreatorSidebar/CreatorModeSidebar";
import CreatorModeTopHeader from "../../components/CreatorDashboard/CreatorModeTopHeader";
import EmptyViewStateMobile from "../../components/EmptyStates/EmptyViewStateMobile";
import { isDesktop } from "react-device-detect";
import { useNavigate } from "../../hooks/useNavigate";
import { useOnMount } from "../../hooks/useOnMount";
import { NavigationId } from "../../navigation/AppParamList";
import { useLocation } from "react-router-dom";
import FrozenSubscriptionAccountModal from "../DisplayModal/FrozenSubscriptionAccountModal";

type CreatorModeWrapperProps = {
  children: ReactNode;
  hideSidebar?: boolean;
  preventScroll?: boolean;
  altBackgroundColor?: string;
};

const CreatorModeWrapper = (props: CreatorModeWrapperProps) => {
  const { children, hideSidebar, preventScroll, altBackgroundColor } = props;
  const { account } = useSelector(getAccountState);
  const { accountData, loggedIn } = account;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // States for sidebar
  const refContainer = useRef<HTMLDivElement>(null);
  const [morePanelVisible, setMorePanelVisible] = useState(false);

  useOnMount(() => {
    // Handle Redirecting
    if (loggedIn === LoginState.LOGGED_OUT) {
      navigate(NavigationId.WELCOME);
    } else if (!accountData.inCreatorMode) {
      dispatch(toggleInCreatorMode(accountData.uid, accountData.inCreatorMode));
    }
  });

  const disableMinWidth = useMemo(
    () => pathname.includes(NavigationId.HOME_PROFILE),
    [pathname]
  );

  if (!isDesktop) {
    return <EmptyViewStateMobile />;
  }

  return (
    <div
      ref={refContainer}
      className="ColumnNormal"
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <FrozenSubscriptionAccountModal />
      {accountData.inCreatorMode ? <CreatorModeTopHeader /> : <TopHeader />}
      <div
        className={`RowNormal ${preventScroll ? "PreventScroll" : ""}`}
        style={{ height: "100%", width: "100%", overflowX: "scroll" }}
      >
        {accountData.inCreatorMode && !hideSidebar ? (
          <CreatorModeSidebar
            morePanelVisible={morePanelVisible}
            setMorePanelVisible={setMorePanelVisible}
          />
        ) : null}
        <div
          className={`ColumnNormal ${preventScroll ? "PreventScroll" : ""}`}
          style={{
            height: "100%",
            width: "100%",
            overflowY: preventScroll ? "hidden" : "auto",
            overflowX: "scroll",
            minWidth: disableMinWidth ? undefined : "1000px",
            backgroundColor: altBackgroundColor || undefined,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default memo(CreatorModeWrapper);
